import React, { useContext } from 'react';
import cn from 'classnames';

import styles from './Contact.module.css';
import baseStyle from '../components.module.css';
import Map from './Map';
import Bio from '../About/Bio';
import {
    ageExcept,
    ageExceptUA,
    contactTitle,
    contactTitleUA,
    myBioInfo,
    residenceExcept,
    residenceExceptUA,
    languagesExcept,
    languagesExceptUA,
    freelanceExcept,
    freelanceExceptUA,
} from '../../data/bioInfo';
import LanguageContext from '../context/LanguageContext';

export default function Contact({ className, toContactRef }) {
    const { language } = useContext(LanguageContext);

    return (
        <div className={cn(className, baseStyle.fadeInLeft)} ref={toContactRef}>
            <div className={baseStyle.topField}></div>
            <h2 className={cn(baseStyle.title)}>
                {language === 'en' ? contactTitle : contactTitleUA}
            </h2>
            <Map height={380} width={'100%'} />
            <Bio
                classNameContacts={styles.bioContacts}
                myBioInfo={myBioInfo}
                dots=' . . . .'
                age={language === 'en' ? ageExcept : ageExceptUA}
                residence={
                    language === 'en' ? residenceExcept : residenceExceptUA
                }
                languages={
                    language === 'en' ? languagesExcept : languagesExceptUA
                }
                level='contacts'
                freelance={
                    language === 'en' ? freelanceExcept : freelanceExceptUA
                }
            />
            <div className={baseStyle.bottomField}></div>
        </div>
    );
}
